import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface LanguageSummary {
  languageCode: string;
  preferred: boolean;
}


@Component({
  selector: 'app-language-list-summary',
  templateUrl: './language-list-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageListSummaryComponent {
  // Cached source and sorted view
  private _languages: LanguageSummary[] | null = null;

  @Input() set languages(value: LanguageSummary[] | null) {
    this._languages = value ?? [];
    this.sortedLanguages = this._languages.slice().sort(LanguageListSummaryComponent.preferredFirst);
  }
  get languages(): LanguageSummary[] {
    return this._languages ?? [];
  }

  sortedLanguages: LanguageSummary[] = [];

  // Preferred languages first (true before false)
  private static preferredFirst(a?: LanguageSummary, b?: LanguageSummary): number {
    return Number(!!b?.preferred) - Number(!!a?.preferred);
  }

  // Use languageCode as a stable key if available
  trackByLanguageCode = (_: number, item: LanguageSummary) => item?.languageCode ?? _;
}

